




















import Vue from 'vue'
import Component from 'vue-class-component';
import { State, Action, Mutation } from 'vuex-class';
import { Product } from '@/modules/product';
import { notify, Colors } from '@/modules/core/notification';

/**
 * Muestra al usuario una pantalla de confirmación para actualizar un
 * producto.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ProductSaveConfirm extends Vue {

    @State(state => state.product.saveConfirm)
    public visible: boolean

    @State(state => state.product.currentProduct)
    public product: Product

    @Mutation('product/product/save/confirm/show')
    public showSaveConfirm: (show: boolean) => void

    @Action('product/updateProduct')
    public updateProduct: () => void

    public loading = false

    public async save () {
        this.loading = true
        try {
            await this.updateProduct()
        } catch (error) {
            notify('Se ha producido un error al actualizar el producto', Colors.Error)
            this.loading = false
        }

        this.loading = false
    }
}
